export default __webpack_public_path__ + "static/home.url-478e967713b7ecc1a421692e8b3b858a.svg";